/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";

// Material Kit 2 React components
import MKBox from "../../../../components/MKBox";
import MKTypography from "../../../../components/MKTypography";

function About() {
  return (
    <MKBox component="section" pt={{ xs: 2, md: 3 }} pb={2} my={0}>
      <Grid container alignItems="center">
        <Grid item align="center" xs={12} md={12} sx={{ ml: { xs: 0, lg: 0 }, mb: { xs: 2, md: 0 } }}>
          <MKTypography variant="h4">ABOUT WEDNESDAY COIN</MKTypography>
          <br />
          <MKTypography
            variant="body2"
            component={Link}
            href="https://anchor.fm/wizardofdapps/episodes/Episode-11-Wednesday-Coin-with-Mike-Vargas-e4l90l"
            target="_blank"
            rel="noreferrer"
            color="info"
          >
            Listen to our interview on Wizard of DApps!
          </MKTypography>
          <br />
          <br />
          <MKTypography
            variant="body2"
            component={Link}
            href="https://youtu.be/gGZllmr_Qh4?t=1344"
            target="_blank"
            rel="noreferrer"
            color="info"
          >
            Watch the CryptoZombie Feature on YouTube!
          </MKTypography>
          <br />
          <br />
          <MKTypography variant="body1" mb={2}>
            Key features of our coin
          </MKTypography>
          <br />
          <br />
          <MKTypography variant="body2" mb={2}>
            Contract Address: 0x7848ae8f19671dc05966dafbefbbbb0308bdfabd
          </MKTypography>
          <MKTypography variant="body2" mb={2}>
            Symbol: WED
          </MKTypography>
          <MKTypography variant="body2" mb={2}>
            Decimal: 18
          </MKTypography>
          <MKTypography variant="body2" mb={2}>
            Total Supply: 21 Billion
          </MKTypography>
        </Grid>
      </Grid>
    </MKBox>
  );
}

export default About;
